<template>
  <div :class="$style.popup" v-if="isOpen">
    <div :class="$style.overlay" @click="close"></div>
    <div :class="$style.content" @click.stop>
      <div :class="$style.top">
        <div>Оставьте заявку</div>
        <div :class="$style.close" @click.stop="close">
          <img src="/icons/common/cross-black.svg" alt="" />
        </div>
      </div>

      <div :class="$style.body">
        <div :class="$style.container" v-if="!result">
          <div :class="$style.content">
            <div :class="$style.input">
              <input type="text" placeholder="Имя" v-model="formData.name" />
            </div>
            <div :class="$style.input">
              <input
                type="text"
                placeholder="Фамилия"
                v-model="formData.surname"
              />
            </div>
            <div :class="$style.input">
              <input
                type="text"
                placeholder="Группа"
                v-model="formData.group"
              />
            </div>
            <div :class="[$style.input, $style.title]">
              <input type="text" :value="title" readonly />
            </div>
          </div>
          <div :class="$style.bottom">
            <div :class="[$style.button, $style.red]" @click="close">
              Отмена
            </div>
            <div :class="[$style.button, $style.green]" @click="sendForm">
              Отправить
            </div>
          </div>
        </div>
        <div v-else :class="$style.result">{{ result }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TelegramForm",
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      botToken: "8313926598:AAF2Lddin4I6Jn8Sw5H5NessYjDX92UacXg",
      chatId: "-4929883815",
      formData: {
        name: "",
        surname: "",
        group: "",
      },
      result: "",
    };
  },
  methods: {
    close() {
      this.$emit("closeModal", false);
      this.result = "";
    },
    escapeMarkdownV2(text) {
      return text.replace(/[_*[\]()~`>#+=|{}.!-]/g, "\\$&");
    },
    async sendForm() {
      const hasEmptyFields = Object.values(this.formData).some(
        (value) => value.trim() === ""
      );
      if (hasEmptyFields) {
        alert("Пожалуйста, заполните все поля.");
        return;
      }
      const message =
        `*Имя:* _${this.escapeMarkdownV2(this.formData.name)}_\n` +
        `*Фамилия:* _${this.escapeMarkdownV2(this.formData.surname)}_\n` +
        `*Группа:* _${this.escapeMarkdownV2(this.formData.group)}_\n` +
        `*Мероприятие:* _${this.escapeMarkdownV2(this.title)}_`;

      await axios.post(
        `https://api.telegram.org/bot${this.botToken}/sendMessage?parse_mode=MarkdownV2`,
        {
          chat_id: this.chatId,
          text: message,
        }
      );

      this.formData = {
        name: "",
        surname: "",
        group: "",
      };
      this.result =
        "Ваша заявка успешно отправлена. Для подтверждения с вами свяжется администрация";
    },
  },
};
</script>

<style lang="scss" module>
@keyframes expand {
  from {
    transform: scale(0.7);
    opacity: 0;
    background-color: $bg;
  }
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(1.25rem);
    transition: opacity 0.3ms;
    z-index: 70;
    animation: expand 0.2s ease-in-out;
  }
  .content {
    max-height: calc(100vh - 4rem);
    overflow: auto;
    @include scrollbarY;
    background-color: #fff;
    border-radius: 0.5rem;
    z-index: 70;
    animation: expand 0.2s ease-in-out;
    min-width: 37.5rem;
    @include custom(1024) {
      min-width: 0;
      width: auto;
    }
    .top {
      padding: 1.5rem;
      text-align: center;
      font-size: 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      @include custom(410) {
        font-size: 1.5rem;
      }
      .close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        background-color: $bg;
        cursor: pointer;
      }
    }
    .body {
      .container {
        .content {
          padding: 1.5rem;
          border-top: 1px solid $bg;
          .input {
            margin: 0 0 0.5rem 0;
            &:last-child {
              margin: 0;
            }
            input {
              border-radius: 0.25rem;
              width: 100%;
              background-color: $bg;
              border: none;
              font-size: 0.875rem;
              font-weight: 400;
              padding: 1rem;
            }
            .last {
              padding-bottom: 3rem;
            }
            &.title {
              input {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
        }
        .bottom {
          padding: 1rem;
          border-top: 1px solid $bg;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1.5rem;
          .button {
            padding: 0.875rem 0;
            cursor: pointer;
            text-align: center;
            border-radius: 0.25rem;
            &.red {
              border: 1px solid $red;
              color: $red;
            }
            &.green {
              border: 1px solid $main;
              color: $white;
              background-color: $main;
            }
          }
        }
      }
    }
  }
  .result {
    text-align: center;
    padding-bottom: 2rem;
    font-size: 0.8rem;
    max-width: 20rem;
    margin: 0 auto;
  }
}
</style>
